import React from 'react';
import ReviewSummary from 'components/review/ReviewSummary';
import ReviewCard from 'components/review/ReviewCard';
import NoData from 'components/common/NoData';
import 'assets/scss/pages/Review.scss';

const ReviewList = ({
    summary = null,
    reviews = [],
    hasMore = false,
    loading = false,
    onLoadMore,
}) => {
    return (
        <div className="review-list">
            {summary && <ReviewSummary summary={summary} />}
            <div className="review-list__items">
                {reviews.length === 0 && !loading ? (
                    <NoData
                        title="아직 리뷰가 없어요"
                        desc="첫 번째 리뷰를 남겨보세요"
                    />
                ) : (
                    reviews.map((review) => <ReviewCard key={review.id} review={review} />
                    )
                )}
            </div>
            {hasMore && (
                <div className="review-list__more-wrap">
                    <button
                        type="button"
                        className="review-list__more-btn"
                        onClick={onLoadMore}
                        disabled={loading}
                    >
                        {loading ? '불러오는 중...' : '리뷰 더보기'}
                    </button>
                </div>
            )}
        </div>
    );
};

export default ReviewList;